import { useTranslations } from 'next-intl';
import { ListingDiscountTypeEnum } from '@/__generated__/graphql';

export const Badge = ({ value, type = ListingDiscountTypeEnum.None }) => {
  const t = useTranslations();

  return (
    <div
      className={`absolute z-10 min-h-[36px] top-0 left-0 pl-3 pr-2 py-1.5 ${value >= 18 ? 'bg-rose-500 text-rose-100 ' : value >= 10 ? 'bg-amber-500 text-amber-100 ' : 'bg-primary-500 text-primary-100 '} rounded-br-md justify-center items-center gap-2 inline-flex`}
    >
      <div
        className="text-[10px] leading-[normal] font-bold uppercase tracking-[0.5px]"
        dangerouslySetInnerHTML={{
          __html: t.raw(`listings.result.badge-discount-type.${type}`),
        }}
      />
      <div className="min-w-[34px] text-right text-white text-base leading-[normal] font-bold uppercase tracking-[0.8px]">
        -{value}%
      </div>
    </div>
  );
};
